import React from "react";

export const TableHead = (props) => {
  return (
    <tr style={{ wordBreak: "break-word" }}>
      <th style={{ width: "25%" }}>Category ID</th>
      <th style={{ width: "20%" }}>Category Name</th>
      <th style={{ width: "10%" }}>
        No. Of <br />
        Items
      </th>
      <th style={{ width: "20%" }}>
        Cross Selling
        <br />
        Categories
      </th>
      <th style={{ width: "15%" }}>Status</th>
      <th style={{ width: "20%" }}>Availability</th>
    </tr>
  );
};
